import { Component, OnInit } from '@angular/core';
import { Forms, QuestionPriority} from "../../../constans/formsQuestions";
import {Router} from "@angular/router";
import {FormMainCategory} from "../../../models/forms.model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, finalize, map} from "rxjs/operators";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {AdvFormService} from "../services/adv-form.service";




@Component({
    selector: 'app-main-category-component',
    templateUrl: './main-category.component.html',
    styleUrls: ['./main-category.component.css'],
    standalone: false
})
export class MainCategoryComponent implements OnInit {

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }

  firstCategory:FormMainCategory[]=[]
  secondCategory:FormMainCategory[]=[]
  thirdCategory:FormMainCategory[]=[]
  selectedCategory!: FormMainCategory |undefined;
  isLoading = false;
  loadError = false;
  isNavigating = false;

  constructor(private router: Router, private http: HttpClient, private apiKey: ApiUrl, private formService: AdvFormService) { }

  ngOnInit(): void {
    this.loadData()
  }

  loadData (): void{
    this.isLoading = true;
    this.loadError = false;
    this.firstCategory = [];
    this.secondCategory = [];
    this.thirdCategory = [];
    this.formService.loadAdsRouts();
    this.getMainCategory()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: res => {
          (res || []).forEach((cate:any)=>{
            if(cate.priority == QuestionPriority.FIRST)
              this.firstCategory.push(cate);
            else if(cate.priority == QuestionPriority.SECOND){
              this.secondCategory.push(cate);
            }else if(cate.priority == QuestionPriority.THIRD){
              this.thirdCategory.push(cate);
            }
          })
        },
        error: () => {
          this.loadError = true;
        }
      });
  }

  private handleObserverError(error: any): Observable<any>{
    return throwError(error.error || error)
  }

  // SCRUM-140: some categories come from the API with an empty icon, which
  // rendered a blank slot next to the name. Fall back to a per-category icon.
  private static readonly FALLBACK_ICONS: Record<string, string> = {
    CAR: 'directions_car', NADLAN: 'home', SALE2: 'shopping_cart',
    REQUIRED: 'person_add', NADLANBUSINESS: 'domain', COWORKER: 'work',
    CELLULAR: 'phonelink_ring', FURNITURE: 'chair', FASHION: 'checkroom',
    PET: 'pets', BOYBABY: 'child_friendly', TEACHER: 'school',
    TOURISM: 'luggage', BUSINESS: 'business_center',
  };
  iconFor(category: any): string {
    const icon = (category?.icon || '').trim();
    if (icon && icon.toLowerCase() !== 'none') return icon;
    return MainCategoryComponent.FALLBACK_ICONS[String(category?.category || '').toUpperCase()] || 'category';
  }

  getMainCategory(): Observable<any>{
    return this.http.get(this.apiKey.getMainCategory(), this.options)
      .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
      );
  }
  SelectMainCategory(selectedCategory:FormMainCategory) {
    if (this.isNavigating) return;
    this.selectedCategory = selectedCategory
    this.isNavigating = true;
    this.formService.addQuestion('mainCategory',this.selectedCategory)
    this.router.navigate(['/publish/'+selectedCategory.category.toLowerCase()])
      .then(navigated => {
        if (!navigated) this.isNavigating = false;
      })
      .catch(() => this.isNavigating = false);
  }
}
